import {
    ADD_INVOICE_DETAIL_BUY_GOODS_AND_SERVICES,
    UPDATE_INVOICE_DETAIL_BUY_GOODS_AND_SERVICES,
    SET_ITBIS_TAX_BUY_GOODS_AND_SERVICES,
    DELETE_INVOICE_DETAIL_BUY_GOODS_AND_SERVICES,
    RESET_BUY_GOODS_AND_SERVICES,
    SET_DYNAMIC_TAX_INPUT_BUY_GOODS_AND_SERVICES,
    SET_DYNAMIC_INPUTS_VALUE_BUY_GOODS_AND_SERVICES
} from '../../../../constants/ActionTypes'
// import { currencyFormat } from '../../../../util/DaFrameword'
import { ID } from '../../../../constants/Config'
const InitialState = {
    TableData: [],
    percentItbis: null,
    IdCurrentRow: ID(),
    DynamicTaxInputs:[],
    DynamicInputValue:[]
}
function BuyGoodsAndService(state = InitialState, action) {
    switch (action.type) {
        case ADD_INVOICE_DETAIL_BUY_GOODS_AND_SERVICES:
            const NewRow = action.payload;
            console.log("Agregar", NewRow)
            return {
                ...state,
                TableData: [...state.TableData, NewRow],
                IdCurrentRow: ID()
            }
        case UPDATE_INVOICE_DETAIL_BUY_GOODS_AND_SERVICES:
            const UpdateRow = action.payload;
            return {
                ...state,
                TableData: state.TableData.map(x => x.id === UpdateRow.id ? UpdateRow : x)
            }
        case DELETE_INVOICE_DETAIL_BUY_GOODS_AND_SERVICES:
            const { productId } = action.payload;
            return {
                ...state,
                TableData: state.TableData.filter(x => x.productId !== productId)
            }
        case SET_ITBIS_TAX_BUY_GOODS_AND_SERVICES:
            return {
                ...state,
                percentItbis: action.payload.percentItbis * 0.01
            }

        case RESET_BUY_GOODS_AND_SERVICES:
            return {
                ...state,
                TableData: [],
                IdCurrentRow: ID(),
                DynamicInputValue:[]
            }
        case SET_DYNAMIC_TAX_INPUT_BUY_GOODS_AND_SERVICES:
            return {
                ...state,
                DynamicTaxInputs:action.payload
            }
        case SET_DYNAMIC_INPUTS_VALUE_BUY_GOODS_AND_SERVICES:
            return{
                ...state,
                DynamicInputValue:action.payload
            }
        default:
            return state;
    }
}

export default BuyGoodsAndService;